// extracted by mini-css-extract-plugin
export default {"templateStylesContainer":"QB5mcLKsISBqYqxByYyp","scrollingSectionGap":"yKPzf2KajTcvaN4FYW5v"};